import { Box, LinearProgress } from '@mui/material';

/** Suspense fallback for lazily-loaded route chunks (spec §4: route loading). */
export function RouteFallback() {
  return (
    <Box sx={{ width: '100%', py: 6 }} role="status" aria-live="polite" aria-busy="true">
      <LinearProgress aria-label="Loading page" />
    </Box>
  );
}
